<div class="container">
    <div class="cards-in-line">
        <div class="card img img1"></div>
        <div class="card text">
            <div class="title"> {{content.reasonUseUs}} </div>
            <span class="content">{{content.content_1}}
            </span>
        </div>
    </div>
    <div class="cards-in-line">
        <div class="card img img2"></div>
        <div class="card text">
            <div class="title"> {{content.reasonUseUs2}} </div>
            <span class="content" >{{content.content_2}}
            </span>
        </div>
    </div>
</div>